export default __webpack_public_path__ + "static/mobile_sek2_KV17-a8a1c499c40a323dd0d9dca0670144b0.mp4";